import { render, staticRenderFns } from "./CreateSlide.vue?vue&type=template&id=b82e54c4&"
import script from "./CreateSlide.vue?vue&type=script&lang=js&"
export * from "./CreateSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports